import React from 'react';

const Programare = ()=> {
    return (
      <div>
        <div style={{ height: "700px"}}>
            <iframe
                src="https://calendly.com/donboscobc/confirmare-inscriere-vara-impreuna-2023"
                width="100%"
                height="100%"
                frameborder="0"
            ></iframe>
        </div>
      </div>
    );
}

export default Programare;
